import { configureStore, createSlice } from '@reduxjs/toolkit'

const initialState = {
  whatsapp: '7010690812',
  formspreeId: 'meeloebp',
  trips: [
    { id: 4, slug: 'tirunelveli-2d1n', title: 'Tirunelveli — 2 Days / 1 Night', desc: 'Waterfalls, dams, temples and local halwa.', price: 'From ₹4,499' },
    { id: 5, slug: 'tenkasi-kutralam', title: 'Tenkasi & Kutralam — 3 Days / 2 Nights', desc: 'Medicinal waterfalls, temples, eco-tourism and relaxation.', price: 'From ₹5,999' },
    { id: 6, slug: 'kanyakumari', title: 'Kanyakumari — 3 Days / 2 Nights', desc: 'Three-ocean confluence, coastal forts, temples and spiritual heritage.', price: 'From ₹6,499' }
  ]
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setFormspreeId(state, action){ state.formspreeId = action.payload }
  }
})

export const { setFormspreeId } = appSlice.actions

const store = configureStore({ reducer: { app: appSlice.reducer } })
export default store
